<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Team Announcements
            </h4>
            <button class="btn btn-outline-primary pull-right" data-target="#newTeamAnnouncementModal" data-toggle="modal"
                    @click="fixModal('add')"><i class="fa fa-bullhorn"></i> Add New Announcement
            </button>
          </div>
          <div class="card-body">
            <div v-if="loading || AcknowledgeLoading" class="loader"></div>
            <table v-else class="table table-striped table-bordered team-announcement-datatable">
              <thead>
              <tr>
                <th>Title</th>
                <th>Created By</th>
                <th>Created At</th>
                <th class="text-center">Is Acknowledged</th>
                <th class="text-center">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(announcement, index) in announcements" :key="announcement.id">
                <td>{{ announcement.title }}</td>
                <td>{{ announcement.createdBy }}</td>
                <td>{{ announcement.createdAt | formatDate }}</td>
                <td class="text-center">
                  <button v-if="announcement.acknowledgements && !announcement.acknowledgements.includes(user.uid)"
                          :disabled="selectedIndex === index"
                          class="btn btn-primary btn-sm mt-0 mb-0" @click="acknowledge(announcement, index)">Acknowledge
                  </button>
                  <i v-else class="fa fa-check-circle text-success fs-20"></i>
                </td>
                <!--                <td>{{announcement.updatedAt | formatDate}}</td>-->
                <td class="text-center" width="15%">
                  <button class="btn btn-sm btn-outline-primary mr-2" title="Edit"
                          @click="openAnnouncement(announcement, 'edit')"><i class="fa fa-pencil"></i></button>
                  <button class="btn btn-sm btn-outline-primary mr-2" title="View"
                          @click="openAnnouncement(announcement, 'view')"><i class="fa fa-eye"></i></button>
                  <button class="btn btn-sm btn-outline-danger" title="Delete"
                          @click="deleteAnnouncement(announcement)"><i class="fa fa-times"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="new-team-announcement-modal position-relative">
      <div id="newTeamAnnouncementModal" aria-hidden="true" aria-labelledby="newTeamAnnouncementModal" class="modal fade newTeamAnnouncementModal"
           role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="type === 'edit' || type === 'add'" id="exampleModalLabel" class="modal-title">
                {{ (type === 'add') ? 'Make New Announcement' : 'Update Announcement' }}</h5>
              <h5 v-else id="exampleModalLabel" class="modal-title"><b>{{ selectedAnnouncement.title }}</b></h5>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <template>
                <div class="form-group">
                  <label>Title <span class="text-danger">*</span></label>
                  <input v-model="selectedAnnouncement.title" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Announcement <span class="text-danger">*</span></label>
                  <textarea ref="editor">
                  </textarea>
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" type="button" @click="type = ''">Close</button>
              <button v-if="type === 'add'" :disabled=" loading || checkHasTitle(selectedAnnouncement.title)" class="btn btn-primary"
                      type="button" @click="submit()">
                <div v-if="loading" class="loader small_loader"></div>
                <span v-else>Submit</span>
              </button>
              <button v-else-if="type === 'edit'" :disabled="loading || checkHasTitle(selectedAnnouncement.title)" class="btn btn-primary"
                      type="button" @click="submit()">
                <div v-if="loading" class="loader small_loader"></div>
                <span v-else>Update</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="view-modal position-relative">
      <div id="viewModal" aria-hidden="true" aria-labelledby="viewModal" class="modal fade viewModal" role="dialog"
           tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 id="viewModalLabel" class="modal-title"><b>{{ selectedAnnouncement.title }}</b></h5>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="p-3" style="border-style: ridge">
                <perfect-scrollbar class="scroll-area">
                  <div v-html="selectedAnnouncement.text"></div>

                </perfect-scrollbar>
              </div>
              <template>
                <h6 class="mt-6">Those who have acknowledged this announcement</h6>
                <perfect-scrollbar class="scroll-area">
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between">
                      <span><b>Name</b></span>
                      <span><b>Status</b></span>
                    </li>
                    <li v-for="(row2,index2) in staffUsers" :key="index2"
                        :class="{'bg-offwhite' : row2.uid === user.uid}"
                        class="list-group-item d-flex justify-content-between">
                    <span>
                      {{ row2.name }}
                    </span>
                      <span class="mr-13">
                        <i v-if="selectedAnnouncement.acknowledgements && selectedAnnouncement.acknowledgements.includes(row2.uid)"
                           class="fa fa-check-circle text-success fs-20"></i>
                        <i v-else class="fa fa-times-circle text-danger fs-20"></i>
                      </span>
                    </li>

                  </ul>
                </perfect-scrollbar>
              </template>

            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" type="button" @click="type = ''">Close</button>
              <!--              <button v-if="type === 'add'" type="button" class="btn btn-primary" :disabled="loading" @click="submit()">-->
              <!--                <div class="loader small_loader" v-if="loading"></div>-->
              <!--                <span v-else>Submit</span>-->
              <!--              </button>-->
              <!--              <button v-else-if="type === 'edit' && user.userType === 'admin' || user.userType === 'super-admin'" type="button" class="btn btn-primary" :disabled="loading" @click="submit()">-->
              <!--                <div class="loader small_loader" v-if="loading"></div>-->
              <!--                <span v-else>Update</span>-->
              <!--              </button>-->
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {VueEditor} from "vue2-editor";

export default {
  name: "team-announcements",
  components: {
    PerfectScrollbar, VueEditor
  },
  data() {
    return {
      content: '',
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        ["image", "code"]
      ],
      editorDiv: null,
      announcements: [],
      loading: true,
      AcknowledgeLoading: false,
      type: '',
      selectedAnnouncement: {
        enabled: false,
        text: '',
        title: '',
        createdBy: '',
        createdAt: '',
        acknowledgements: []
      },
      selectedIndex: -1,
      staffUsers: [],
      listener: null
    }
  },
  watch: {
    editorDiv(val) {
      if (!val) {
        this.initiateEditor()
      }
    },
    announcements(val) {
      if (this.showSingleAnnouncement) {
        if (val.length) {
          const announcements = val.find((value) => !value.acknowledgements.includes(this.user.uid))
          this.$store.commit('mutateSingleAnnouncement', false);
          this.openAnnouncement(announcements)
        }
      }
    },
    showSingleAnnouncement(val) {
      if (val) {
        const announcements = this.announcements.find((value) => !value.acknowledgements.includes(this.user.uid))
        if (announcements) {
          this.$store.commit('mutateSingleAnnouncement', false);
          this.openAnnouncement(announcements)
        }
      }
    }
  },
  beforeDestroy() {
    if (this.listener) {
      this.listener()
    }
  },
  mounted() {
    this.loading = true;
    this.initiateSnapshot()
    // this.getAnnouncements();
    this.getStaffUsers();
    this.initiateEditor()
    $('#newTeamAnnouncementModal').on('hidden.bs.modal', () => {
      this.selectedAnnouncement = {
        enabled: false,
        text: '',
        type: 'alert-info',
        acknowledgements: []
      }
    })
    setTimeout(() => {
      this.loading = false;
    }, 600)
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    showSingleAnnouncement() {
      return this.$store.getters.getShowSingleAnnouncement;
    },
  },

  methods: {
    checkHasTitle(val) {
      if (val) {
        val = val.trim();
        return val.length <= 0;
      }
      return true
    },
    initiateEditor() {
      CKEDITOR.ClassicEditor.create(this.$refs.editor, {
        // 'todoList', 'subscript', 'superscript', 'fontBackgroundColor', 'htmlEmbed', 'specialCharacters', 'horizontalLine', 'pageBreak', '|', 'textPartLanguage', '|', 'sourceEditing'

        // https://ckeditor.com/docs/ckeditor5/latest/features/toolbar/toolbar.html#extended-toolbar-configuration-format
        height: '300px',
        readOnly: true,
        toolbar: {
          items: [
            'heading', '|',
            'bold', 'italic', 'strikethrough', 'underline', 'code', 'removeFormat', '|',
            'bulletedList', 'numberedList', '|',
            'outdent', 'indent', '|',
            'undo', 'redo',
            '-',
            'fontSize', 'fontFamily', 'fontColor', 'highlight', '|',
            'alignment', '|',
            'link', 'insertImage', 'blockQuote', 'insertTable', 'mediaEmbed', 'codeBlock', '|',
          ],
          shouldNotGroupWhenFull: true
        },
        image: {
          // Allow images from external sources
          uploadUrl: null,
          toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'linkImage']
        },
        // Changing the language of the interface requires loading the language file using the <script> tag.
        // language: 'es',
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/headings.html#configuration
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'},
            {model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4'},
            {model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5'},
            {model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6'}
          ]
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/editor-placeholder.html#using-the-editor-configuration
        // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-family-feature
        fontFamily: {
          options: [
            'default',
            'Arial, Helvetica, sans-serif',
            'Courier New, Courier, monospace',
            'Georgia, serif',
            'Lucida Sans Unicode, Lucida Grande, sans-serif',
            'Tahoma, Geneva, sans-serif',
            'Times New Roman, Times, serif',
            'Trebuchet MS, Helvetica, sans-serif',
            'Verdana, Geneva, sans-serif'
          ],
          supportAllValues: true
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-size-feature
        fontSize: {
          options: [10, 12, 14, 'default', 18, 20, 22],
          supportAllValues: true
        },
        // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
        // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        },
        // Be careful with enabling previews
        // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
        htmlEmbed: {
          showPreviews: true
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
        link: {
          decorators: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://',
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            }
          }
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/mentions.html#configuration
        mention: {
          feeds: [
            {
              marker: '@',
              feed: [
                '@channel', '@here'
              ],
              minimumCharacters: 1
            }
          ]
        },
        // The "super-build" contains more premium features that require additional configuration, disable them below.
        // Do not turn them on unless you read the documentation and know how to configure them and setup the editor.
        removePlugins: [
          // These two are commercial, but you can try them out without registering to a trial.
          // 'ExportPdf',
          // 'ExportWord',
          'CKBox',
          'CKFinder',
          'EasyImage',
          // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
          // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
          // Storing images as Base64 is usually a very bad idea.
          // Replace it on production website with other solutions:
          // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
          // 'Base64UploadAdapter',
          'RealTimeCollaborativeComments',
          'RealTimeCollaborativeTrackChanges',
          'RealTimeCollaborativeRevisionHistory',
          'PresenceList',
          'Comments',
          'TrackChanges',
          'TrackChangesData',
          'RevisionHistory',
          'Pagination',
          'WProofreader',
          // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
          // from a local file system (file://) - load this site via HTTP server if you enable MathType.
          'MathType',
          // The following features are part of the Productivity Pack and require additional license.
          'SlashCommand',
          'Template',
          'DocumentOutline',
          'FormatPainter',
          'TableOfContents'
        ]
      }).then(el => {
        this.editorDiv = el
      })
    },
    async acknowledge(data, index) {
      this.selectedIndex = index;
      $(".team-announcement-datatable").DataTable().destroy();
      this.AcknowledgeLoading = true;
      console.log(data, this.selectedAnnouncement)
      try {
        if (!data.acknowledgements) {
          data.acknowledgements = []
        }
        const getRef = await db.collection('team-announcements').doc(data.id).get();
        if (getRef.exists) {
          const {acknowledgements} = getRef.data();
          if (acknowledgements.includes(this.user.uid)) {
            swal('Success', 'You have successfully acknowledged the announcement!', 'success')
            return
          }
        }
        data.acknowledgements.push(this.user.uid);
        await db.collection('team-announcements').doc(data.id).update({acknowledgements: data.acknowledgements})
        // reduce counter in counters document of team-announcements
        const ref = await db.collection('team-announcements').doc('counter').get();
        console.log('counter doc', ref.exists)
        if (ref.exists) {
          const {staffMembers} = ref.data();
          const obj = staffMembers.find(el => el.uid === this.user.uid);
          if (obj && obj.counter > 0) {
            obj.counter -= 1;
          }
          await db.collection('team-announcements').doc(ref.id).update({staffMembers})
        }
        swal('Success', 'You have successfully acknowledged the announcement!', 'success')
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Something went wrong while acknowledging!!', 'error')
      } finally {
        this.AcknowledgeLoading = false;
        this.initDataTable();
        this.selectedIndex = -1;
      }
    },
    async fixModal(val) {
      this.type = val
      if (val === 'add') {
        this.selectedAnnouncement = {
          title: '',
          text: '',
          acknowledgements: []
        }
        if (this.editorDiv) {
          this.editorDiv.setData('');
        }
      }
      // await this.initiateEditor()
      /* eslint-disable */
      $(document).ready(function () {
        $(".modal-backdrop").appendTo(".new-team-announcement-modal");
      });
      /* eslint-enable */
    },
    getAnnouncements() {
      this.announcements = [];
      $(".team-announcement-datatable").DataTable().destroy();
      const announcementQuery = db.collection('team-announcements').orderBy('createdAt', "desc").limit(100);
      announcementQuery.get().then(docs => {
        let ann = [];
        docs.forEach(doc => {
          ann.push({id: doc.id, ...doc.data()});
        });
        this.announcements = ann;
        console.log('announcments', this.announcements)
      }).finally(() => {
        this.loading = false;
        this.initDataTable();
      })

    },
    initiateSnapshot() {
      try {
        this.announcements = [];
        let query = db.collection('team-announcements').orderBy('createdAt', "desc").limit(100);
        // .limit(500);

        this.listener = query.onSnapshot(
            {includeMetadataChanges: true},
            (snapshot) => {
              snapshot.docChanges().forEach((change) => {
                if (change.type === 'added') {
                  const data = change.doc.data();
                  this.announcements.push({id: change.doc.id, ...data});
                } else if (change.type === 'modified') {
                  this.announcements = this.announcements.filter(el => el.id !== change.doc.id)
                  this.announcements.unshift({id: change.doc.id, ...change.doc.data()})
                } else if (change.type === 'removed') {
                  this.announcements = this.announcements.filter(el => el.id !== change.doc.id)
                }
                // Handle other change types like 'modified' or 'removed' if needed
              });
              this.initDataTable()
            },
            (error) => {
              console.error('Error fetching snapshot:', error);
            }
        );
      } catch (e) {
        console.log(e.toString())
      } finally {
        // this.loading = false
      }

    },
    async getStaffUsers() {
      console.log('get staff users')
      this.staffUsers = [];
      const query = await db.collection('users').where('userType', 'in', ['admin', 'manager']).get();
      console.log(query.size)
      if (query.size) {
        query.forEach(el => {
          const data = el.data();
          this.staffUsers.push({uid: el.id, name: `${data.firstName} ${data.lastName}`, counter: 0})
        })
      }
      console.log(this.staffUsers)
    },
    initDataTable() {
      /* eslint-disable */
      $(document).ready(function () {
        $(".team-announcement-datatable").DataTable().destroy();
        $(".team-announcement-datatable").DataTable({
          ordering: false,
          retrieve: true,
          language: {
            search: "_INPUT_",
            searchPlaceholder: "Search Announcement",
            emptyTable: "No announcement exist in the system",
            size: '40'
          }
        });
        $('#newTeamAnnouncementModal').modal('hide');
      });
      /* eslint-enable */
    },
    async openAnnouncement(announcement, type) {
      this.selectedAnnouncement = JSON.parse(JSON.stringify(announcement));
      if (type === 'edit') {
        console.log(this.editorDiv)
        this.editorDiv.setData(this.selectedAnnouncement.text)
        $("#newTeamAnnouncementModal").modal('show');
      } else {
        $("#viewModal").modal('show');
      }
      this.fixModal(type)
    },
    customizeText() {
      // Get current date in EST
      const currentDate = new Date();
      const estDate = new Date(currentDate.toLocaleString("en-US", {timeZone: "America/New_York"}));

      // Format date and time
      const formattedTime = estDate.toLocaleString("en-US", {hour: "numeric", minute: "numeric", hour12: true});
      const formattedDate = estDate.toLocaleString("en-US", {day: "numeric", month: "short", year: "numeric"});

      // Create the final formatted string
      const formattedString = `${formattedTime} EST | ${formattedDate}`;

      console.log(formattedString);

      let beforeText = `<p><strong>------ ${this.selectedAnnouncement.title.toUpperCase()} | BY ${this.selectedAnnouncement.createdBy.toUpperCase()} | ${formattedString} ------ </strong></p>`
      // let afterText = `<p><strong>------ END ANNOUNCEMENT ------ </strong></p>`
      this.selectedAnnouncement.text = beforeText + this.selectedAnnouncement.text
    },
    async submit() {
      const text = await this.editorDiv.getData();
      this.selectedAnnouncement.text = text;
      if (this.selectedAnnouncement.title.trim() === '' || this.selectedAnnouncement.text.trim() === '') {
        return
      }
      try {
        this.loading = true;
        if (this.type === 'edit') {
          const id = this.selectedAnnouncement.id;
          delete this.selectedAnnouncement.id;
          this.selectedAnnouncement.updatedAt = new Date().toISOString();
          await this.customizeText()
          console.log(this.selectedAnnouncement.text)
          // await this.$http.post('/team-announcement/notify-slack', {
          //   grant_type: 'token',
          //   announcement: this.selectedAnnouncement.text
          // })
          this.selectedAnnouncement.text = text
          await db.collection('team-announcements').doc(id).update(this.selectedAnnouncement)
        } else if (this.type === 'add') {
          this.selectedAnnouncement.createdBy = `${this.user.firstName} ${this.user.lastName}`
          const ref = await db.collection('team-announcements').doc('counter').get();
          let staffMembers = [];
          // add admin and manager list to counter document for acknowledgement purposes
          if (!ref.exists) {
            console.log('members list', this.staffUsers)
            await db.collection('team-announcements').doc('counter').set({
              staffMembers: this.staffUsers
            })
            staffMembers = this.staffUsers
          } else {
            staffMembers = ref.data().staffMembers;
          }
          if (this.staffUsers.length !== staffMembers.length) {
            for (const row of this.staffUsers) {
              const obj = staffMembers.find(el => el.uid === row.uid)
              if (!obj) {
                staffMembers.push({uid: row.uid, name: `${row.name}`, counter: 0})
              }
            }
          }
          for (const row of staffMembers) {
            if (row.uid !== this.user.uid) {
              row.counter += 1

            }
          }
          await this.customizeText()
          await this.$http.post('/team-announcement/notify-slack', {  // uncomment this later.
            grant_type: 'token',
            announcement: this.selectedAnnouncement.text
          })
          await db.collection('team-announcements').doc('counter').update({staffMembers})
          await db.collection('team-announcements').add({
            title: this.selectedAnnouncement.title,
            text,
            createdBy: this.selectedAnnouncement.createdBy,
            createdAt: new Date().toISOString(),
            acknowledgements: [],
            createdByEmail: this.user.email,
          })
        }
        await this.initDataTable()
        console.log('selected ann', this.selectedAnnouncement)
        swal('Success', 'You have successfully posted announcement!', 'success')
      } catch (e) {
        console.log(e)
        console.log('something went wrong while saving new team announcement', e.toString())
        swal('Error', 'Something went wrong while saving team announcement!', 'error')

      } finally {
        this.selectedAnnouncement = {
          enabled: false,
          text: '',
          title: '',
          createdBy: '',
          createdAt: '',
          acknowledgements: []
        }
        this.loading = false;
      }
    },

    async deleteAnnouncement(announcement) {
      try {
        console.log(announcement)
        const resp = await swal({
          title: 'Are you sure?',
          text: 'Are you sure to delete this announcement!',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: "#6ACF98",
          cancelButtonColor: "#EE8057"
        })
        if (resp.value) {
          this.loading = true;
          const query = await db.collection('team-announcements').doc('counter').get();
          if (query.exists) {
            const {staffMembers} = query.data();
            for (const row of staffMembers) {
              const obj = announcement.acknowledgements.find(el => el === row.uid);
              if (!obj && row.counter > 0) {
                row.counter -= 1;
              }
            }
            await db.collection('team-announcements').doc('counter').update({staffMembers});
          }
          await db.collection('team-announcements').doc(announcement.id).delete()
          // await this.getAnnouncements();
          swal('Success!', 'Announcement has been deleted successfully', 'success');
          this.addLog({
            message: `User has deleted an Announcement!`,
            level: "info"
          })
        }
      } catch (e) {
        swal('Error!', 'Something went wrong while deleting announcement', 'error');
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.scroll-area {
  max-height: 400px;
  overflow: hidden;
}

.fs-20 {
  font-size: 20px;
}

.bg-offwhite {
  background-color: rgba(251, 198, 88, 0.1);
}

.v-toast__icon {
  color: darkgreen;
}

.v-toast__item.v-toast__item--success .v-toast__icon {
  display: block !important;
}

.v-toast__item {
  height: 90px !important;
  width: 340px !important;
  background-color: #DEFBE6 !important;
  color: darkgreen !important;
  border-left: darkgreen !important;
  border-left-style: solid !important;
}
</style>
